export const languagesEnum = {
    TR: 'tr',
    EN: 'en',
    DE: 'de'
};